function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#DOT_svg__clip0_1_45)",
  fill: "#E6007A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.999 6.292c2.987 0 5.41-1.408 5.41-3.146C20.408 1.41 17.986 0 14.998 0s-5.41 1.409-5.41 3.146c0 1.738 2.422 3.146 5.41 3.146zM14.999 29.998c2.987 0 5.41-1.409 5.41-3.146 0-1.738-2.422-3.146-5.41-3.146s-5.41 1.408-5.41 3.146c0 1.737 2.422 3.146 5.41 3.146zM7.46 10.647C8.954 8.06 8.945 5.257 7.44 4.39c-1.506-.87-3.938.523-5.431 3.11-1.494 2.587-1.484 5.39.021 6.259 1.506.87 3.938-.523 5.431-3.11zM27.988 22.499c1.494-2.588 1.485-5.39-.02-6.258-1.505-.869-3.936.524-5.43 3.111-1.493 2.588-1.484 5.39.02 6.258 1.505.869 3.936-.524 5.43-3.111zM7.44 25.61c1.505-.87 1.515-3.672.021-6.26-1.494-2.587-3.925-3.98-5.431-3.11-1.506.87-1.515 3.672-.022 6.259 1.494 2.587 3.926 3.98 5.432 3.11zM27.97 13.758c1.504-.868 1.513-3.67.02-6.257-1.495-2.587-3.925-3.98-5.43-3.112-1.505.869-1.514 3.67-.02 6.258 1.494 2.587 3.925 3.98 5.43 3.111z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "DOT_svg__clip0_1_45"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "fc57abbad6658aa05f930d5199504876.svg";
export { SvgDot as ReactComponent };